<script>
import Main from '../public_pages/Main';
import Gallery from '../public_pages/Gallery';
import History from '../public_pages/History';
import News from '../public_pages/News';
import Leadership from '../public_pages/Leadership';
import Enrollee from '../public_pages/Enrollee';
import Specialty from '../public_pages/Specialty';
import International from '../public_pages/International';
import Contacts from '../public_pages/Contacts';

const routes = [
    { path: '/', component: Main },
    { path: '/main', component: Main },
    { path: '/events/gallery', component: Gallery },
    { path: '/events/news', component: News },
    { path: '/about/history', component: History },
    { path: '/leadership', component: Leadership },
    { path: '/enrollee', component: Enrollee },
    { path: '/specialty', component: Specialty },
    { path: '/international-activity', component: International },
    { path: '/contacts', component: Contacts },
];

export default routes;
</script>
